module.exports = __webpack_public_path__ + "img/practical-go-lessons-book7.331e0470.jpg";